// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/smart_order/trailing_stop/order/entity/v1/price_algorithm.proto (package securities.trm.core.smart_order.trailing_stop.order.entity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType
 */
export const PriceAlgorithmType = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithmType",
  [
    {no: 0, name: "PRICE_ALGORITHM_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRICE_ALGORITHM_TYPE_TRAILING_STOP_PERCENTAGE", localName: "TRAILING_STOP_PERCENTAGE"},
  ],
);

/**
 * @generated from message securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm
 */
export const PriceAlgorithm = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.smart_order.trailing_stop.order.entity.v1.PriceAlgorithm",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(PriceAlgorithmType) },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

